// Here we are going to create the code that we need for the section card that we need inside of the Trend Details
function renderSectionalCards(rootElement = document) {
   const sectionalContainer = rootElement.querySelectorAll(
      '.sectional-card-container'
   );

   sectionalContainer.forEach((container) => {
      const sectionCardData = container.getAttribute('data-sectionalcards');

      const parsedSectionData = JSON.parse(sectionCardData);

      if (parsedSectionData) {
         const cardsContainer = document.createElement('div');
         cardsContainer.className = `flex-wrapper card-count-${parsedSectionData.cards.length} ${parsedSectionData?.threeBoxLayout}`;
         const wrapper = document.createElement('div');
         wrapper.className = 'sectional-container';
         const sectionalCardTitle = document.createElement('div');
         sectionalCardTitle.className = `sectional-card-container-title`;
         sectionalCardTitle.innerHTML = parsedSectionData.title;
         wrapper.appendChild(sectionalCardTitle);

         container.appendChild(wrapper);

         wrapper.appendChild(cardsContainer);

         function createImplicationBlock(sectionalCard) {
            const block = document.createElement('div');

            block.className = `card sectional-card-container-block`;
            block.innerHTML = `
            ${sectionalCard.overline ? `<p class="sectional-card-container-head-title">${sectionalCard.overline}</p>`: ``}
            <h3 class="sectional-card-container-title">${sectionalCard.headline}</h3>
            <hr class="sectional-card-container-separator">
            <p class="sectional-card-container-text">${sectionalCard.text}</p>
  `;
            return block;
         }

         parsedSectionData.cards.forEach((sectionalCard) => {
            const block = createImplicationBlock(sectionalCard);
            cardsContainer.appendChild(block);
         });
      }
   });
}

window.addEventListener('DOMContentLoaded', () => {
   renderSectionalCards();

   document.addEventListener('overlay-created', (event) => {
      const overlayContainer = event.detail.overlayContainer;
      renderSectionalCards(overlayContainer);
   });
});
